// extracted by mini-css-extract-plugin
export var container = "partnership-module--container--CI5mB";
export var wrap = "partnership-module--wrap--WVXbk";
export var content = "partnership-module--content--ENwu8";
export var fellowshipPage = "partnership-module--fellowshipPage--aLZ8w";
export var slideUp = "partnership-module--slideUp--pO6N-";
export var slideUpLarge = "partnership-module--slideUpLarge--DwASv";